import { addDays, isoWeekday } from '@squadcore/api/shared/time'

// Used by the route loaders outside the lazy page chunks, so this module stays free of components.

/** The window the overview shows: today and the next 13 days. */
export const overviewRange = (today: string) => ({ from: today, to: addDays(today, 13) })

export type TermineSearch = { ab?: string }

/** Four weeks from Monday of the week containing `day`. */
export function termineRange(day: string) {
  const from = addDays(day, 1 - isoWeekday(day))
  return { from, to: addDays(from, 27) }
}
